import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { JSONRpc } from './service-jsonrpc';
import { Observable, of } from 'rxjs';

import { environment } from '../../environments/environment';
@Injectable({
    providedIn: 'root'
})
export class MailService {

    constructor(
        private http: HttpClient
    ) {}
    

    callPOSTJSONRpc(url, rpcMethod): Observable<any> {
        return this.http.post<JSONRpc>(url + '?' + rpcMethod.method, rpcMethod);
    }

    sendMailToSupport(subject: string, content: string): Observable<any> {
        let rpcMethod = new JSONRpc({
            jsonrpc : "2.0",
            method: "webservice.mail:sendMailToSupport",
            params: {
                subject: subject,
                content: content,
            }
        });
        return this.callPOSTJSONRpc(environment.webservice, rpcMethod);
    }
    
    sendDelegateEmail(senderInfo, recipientInfo, type, dossierId): Observable<any> {
        
        let formData: FormData = new FormData();
        formData.append('sender', senderInfo);
        formData.append('recipient', recipientInfo);
        formData.append('type', type);
        formData.append('dossierId', dossierId);

        return this.http.post(environment.webservice + "sendDelegateEmail", formData);
    }
}